import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import RegisterService from "../../../services/screens/account/RegisterService";
import { ActionTypes } from "../../actionTypes/screens/account/RegisterPartnerActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.account.registerpartner;

//
// Actions
//
const Actions = {
    registerPartnerAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REGISTER_PARTNER_ASYNC, vo });

            RegisterService.registerPartner(
                vo,
                response => {
                    dispatch(Actions.registerPartnerSuccess(response));
                },
                error => {
                    dispatch(Actions.registerPartnerFailure(error));
                }
            );
        };
    },

    registerPartnerSuccess: data => ({
        type: ActionTypes.REGISTER_PARTNER_SUCCESS,
        parentType: ActionTypes.REGISTER_PARTNER_ASYNC,
        data
    }),

    registerPartnerFailure: error => ({
        type: ActionTypes.REGISTER_PARTNER_FAILURE,
        parentType: ActionTypes.REGISTER_PARTNER_ASYNC,
        error
    }),
    
    getUserByEmailAsync: (email) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GETUSER_BY_EMAIL_ASYNC, email });

            RegisterService.getUserByEmail(
                email,
                response => {
                    dispatch(Actions.getUserByEmailSuccess(response, email));
                },
                error => {
                    dispatch(Actions.getUserByEmailFailure(error));
                }
            );
        };
    },

    getUserByEmailSuccess: (data, email) => ({
        type: ActionTypes.GETUSER_BY_EMAIL_SUCCESS,
        parentType: ActionTypes.GETUSER_BY_EMAIL_ASYNC,
        postReducer: getUserByEmailSuccessPostReducer,
        data, email
    }),

    getUserByEmailFailure: error => ({
        type: ActionTypes.GETUSER_BY_EMAIL_FAILURE,
        parentType: ActionTypes.GETUSER_BY_EMAIL_ASYNC,
        error
    }),

    showCountDown: (conutDownType, val) => ({
        type: ActionTypes.SHOW_COUNT_DOWN,
        conutDownType, val,
    }),

    sendCorpCodeAsync: (phone, isoCode, countryCode) =>{
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEND_CORP_CODE_ASYNC, phone, isoCode, countryCode });
            RegisterService.sendCorpCode(phone, isoCode, countryCode, 4, true,
                response => {
                    dispatch(Actions.sendCorpCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.sendCorpCodeFailure(error));
                }
            );
        };
    },

    sendCorpCodeSuccess: data => ({
        type: ActionTypes.SEND_CORP_CODE_SUCCESS,
        parentType: ActionTypes.SEND_CORP_CODE_ASYNC,
        data
    }),

    sendCorpCodeFailure: error => ({
        type: ActionTypes.SEND_CORP_CODE_FAILURE,
        parentType: ActionTypes.SEND_CORP_CODE_ASYNC,
        error
    }),

    getAllCountryCodeAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC });

            RegisterService.getAllCountryCode(
                response => {
                    dispatch(Actions.getAllCountryCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.getAllCountryCodeFailure(error));
                }
            );
        };
    },

    getAllCountryCodeSuccess: data => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        postReducer: getAllCountryCodeSuccessPostReducer,
        data
    }),

    getAllCountryCodeFailure: error => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        error
    }),

    sendSmsVerifyCodeAsync: (phone, isoCode, countryCode ) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEND_SMS_VERIFY_CODE_ASYNC, phone, isoCode, countryCode });

            RegisterService.sendSmsVerifyCode(phone, isoCode, countryCode, 0, true,
                response => {
                    dispatch(Actions.sendSmsVerifyCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.sendSmsVerifyCodeFailure(error));
                }
            );
        };
    },

    sendSmsVerifyCodeSuccess: data => ({
        type: ActionTypes.SEND_SMS_VERIFY_CODE_SUCCESS,
        parentType: ActionTypes.SEND_SMS_VERIFY_CODE_ASYNC,
        data
    }),

    sendSmsVerifyCodeFailure: error => ({
        type: ActionTypes.SEND_SMS_VERIFY_CODE_FAILURE,
        parentType: ActionTypes.SEND_SMS_VERIFY_CODE_ASYNC,
        error
    }),

    sendEmailVerifyCodeAsync: (email) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEND_EMAIL_VERIFY_CODE_ASYNC, email });

            RegisterService.sendEmailVerifyCode(email, 
                response => {
                    dispatch(Actions.sendEmailVerifyCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.sendEmailVerifyCodeFailure(error));
                }
            );
        };
    },

    sendEmailVerifyCodeSuccess: data => ({
        type: ActionTypes.SEND_EMAIL_VERIFY_CODE_SUCCESS,
        parentType: ActionTypes.SEND_EMAIL_VERIFY_CODE_ASYNC,
        data
    }),

    sendEmailVerifyCodeFailure: error => ({
        type: ActionTypes.SEND_EMAIL_VERIFY_CODE_FAILURE,
        parentType: ActionTypes.SEND_EMAIL_VERIFY_CODE_ASYNC,
        error
    }),

    updateSettings: (newData) => ({
        type: ActionTypes.UPDATE_SETTINGS,       
        newData
    }),

    resetToInitialData: () => ({
        type: ActionTypes.RESET_TO_INITIAL_DATA,
    }),

    activeTeacherAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ACTIVE_TEACHER_ASYNC, vo });

            RegisterService.activeTeacher(
                vo,
                response => {
                    dispatch(Actions.activeTeacherSuccess(response));
                },
                error => {
                    dispatch(Actions.activeTeacherFailure(error));
                }
            );
        };
    },

    activeTeacherSuccess: data => ({
        type: ActionTypes.ACTIVE_TEACHER_SUCCESS,
        parentType: ActionTypes.ACTIVE_TEACHER_ASYNC,
        data
    }),

    activeTeacherFailure: error => ({
        type: ActionTypes.ACTIVE_TEACHER_FAILURE,
        parentType: ActionTypes.ACTIVE_TEACHER_ASYNC,
        error
    }),

    loginAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOGIN_ASYNC, vo });

            setTimeout(() => {
                dispatch(Actions.loginSuccess(vo));
            }, 100);
        };
    },

    loginSuccess: data => ({
        type: ActionTypes.LOGIN_SUCCESS,
        parentType: ActionTypes.LOGIN_ASYNC,
        data
    }),

    loginFailure: error => ({
        type: ActionTypes.LOGIN_FAILURE,
        parentType: ActionTypes.LOGIN_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    user: {
        id: "",
        nationality: "",
        organization: "",
        firstName: "",
        email: "",
        phone: "",            
        password: "",
        countryCode: "86-CHN",
    },
    showCorpCode: false,
    showCountDown: false,
    showSmsCodeCountDown: false,
    showEmailCodeCountDown: false,
    countryCodeList: null,
    showPhoneArea: true,
};

//
// Reducers
//
const getUserByEmailSuccessPostReducer = (state, { data, email }) => {
    let newUser = data;
    newUser.email = email;
    newUser.countryCode = data.isoCode + "-" + data.countryCode;
    let showPhoneArea = !(newUser.id && newUser.id !== "" && newUser.phone && newUser.phone !== "");
    return { ...state, user: newUser, showPhoneArea: showPhoneArea };
};

const showCountDownReducer = (state, { conutDownType, val }) => {
    if(conutDownType === 0)
        return { ...state, showCountDown: val };
    else if(conutDownType === 1)
        return { ...state, showSmsCodeCountDown: val };
    else
        return { ...state, showEmailCodeCountDown: val };
};

const getAllCountryCodeSuccessPostReducer = (state, { data }) => {
    return { ...state, countryCodeList: data };
};

const updateSettingsReducer = (state, { newData }) => {
    return { ...state, user: newData, };
};

const resetToInitialDataReducer = (state) => {
    return {
        ...state, user: {
            id: "",
            nationality: "",
            organization: "",
            firstName: "",
            password: "",
            countryCode: "86-CHN",
        },
        showPhoneArea: true,
    };
};
// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.REGISTER_PARTNER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REGISTER_PARTNER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REGISTER_PARTNER_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GETUSER_BY_EMAIL_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GETUSER_BY_EMAIL_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GETUSER_BY_EMAIL_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SHOW_COUNT_DOWN]: showCountDownReducer,
    [ActionTypes.SEND_CORP_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_CORP_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_CORP_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEND_SMS_VERIFY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_SMS_VERIFY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_SMS_VERIFY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEND_EMAIL_VERIFY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_EMAIL_VERIFY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_EMAIL_VERIFY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
    [ActionTypes.RESET_TO_INITIAL_DATA]: resetToInitialDataReducer,
    [ActionTypes.ACTIVE_TEACHER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ACTIVE_TEACHER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ACTIVE_TEACHER_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOGIN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOGIN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOGIN_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
